
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = () => {
  const { user, isLoading } = useAuth();
  
  // If auth is still loading, you might want to show a loading indicator
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  // If no user is authenticated, redirect to auth page
  if (!user) {
    return <Navigate to="/auth" />;
  }
  
  // If user is authenticated, render the child route
  return <Outlet />;
};
